export const textColorMixin = ({ _textColor }: { _textColor?: string }) =>
  `color: ${_textColor ?? 'currentColor'};`;
